import { CountriesResult, findCountries } from '~/Api/Country';
import { invokeApi, resolve } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';

export function fetchCountriesIfNeeded(): ThunkAction<Promise<CountriesResult | null>, any> {
	return (dispatch, getState) => {
		return getState().country.request || dispatch(fetchCountries());
	};
}

export function fetchCountries(): ThunkAction<Promise<CountriesResult | null>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findCountries));
		dispatch({ type: ActionTypes.request, request });

		return resolve(request, (response) =>
			dispatch({
				type: ActionTypes.receive,
				request,
				countries: response?.items,
			})
		);
	};
}
